import { render, staticRenderFns } from "./SimpleContactForm.vue?vue&type=template&id=a55c62b8&scoped=true&"
import script from "./SimpleContactForm.vue?vue&type=script&lang=js&"
export * from "./SimpleContactForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleContactForm.vue?vue&type=style&index=0&id=a55c62b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55c62b8",
  null
  
)

export default component.exports